import { combineReducers } from "@reduxjs/toolkit";
import { reducersFns as baseReducers } from "tsi-common-react/src/apps/retail/reducers";

export const reducers = combineReducers({
    ...baseReducers,
});
